// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------
   🔹 استایل دکمه ثانویه (انصراف)
   ----------------------------------------- */
.secondary-button {
    background: #9e9e9e;           /* خاکستری */
    padding: 15px;
    border: none;
    border-radius: 15px;
    color: #fff;
    font-size: 15px;
    cursor: pointer;
    margin-top: 20px;
    transition: all 0.2s ease;
    display: inline-flex;
    justify-content: center;       /* افقی وسط */
    align-items: center;           /* عمودی وسط */
    gap: 0.5em;
}

/* حالت هاور */
.secondary-button:hover:not(:disabled) {
    background: #8c8c8c;
}

/* حالت دکمه غیرفعال */
.secondary-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* در صورت نیاز به حالت لودینگ */
.secondary-button.is-loading {
    position: relative;
    pointer-events: none;
}

/* آیکن و متن */
.secondary-button .btn-icon {
    display: flex;
}
.secondary-button .btn-title {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/SecondaryButton/SecondaryButton.css"],"names":[],"mappings":"AAAA;;8CAE8C;AAC9C;IACI,mBAAmB,YAAY,YAAY;IAC3C,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oBAAoB;IACpB,uBAAuB,QAAQ,aAAa;IAC5C,mBAAmB,YAAY,cAAc;IAC7C,UAAU;AACd;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB","sourcesContent":["/* -----------------------------------------\n   🔹 استایل دکمه ثانویه (انصراف)\n   ----------------------------------------- */\n.secondary-button {\n    background: #9e9e9e;           /* خاکستری */\n    padding: 15px;\n    border: none;\n    border-radius: 15px;\n    color: #fff;\n    font-size: 15px;\n    cursor: pointer;\n    margin-top: 20px;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    justify-content: center;       /* افقی وسط */\n    align-items: center;           /* عمودی وسط */\n    gap: 0.5em;\n}\n\n/* حالت هاور */\n.secondary-button:hover:not(:disabled) {\n    background: #8c8c8c;\n}\n\n/* حالت دکمه غیرفعال */\n.secondary-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* در صورت نیاز به حالت لودینگ */\n.secondary-button.is-loading {\n    position: relative;\n    pointer-events: none;\n}\n\n/* آیکن و متن */\n.secondary-button .btn-icon {\n    display: flex;\n}\n.secondary-button .btn-title {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
